module.exports = __webpack_public_path__ + "static/media/pacli_target.ba884367.png";